import CodeMirrorInput from "./CodeMirrorInput";
import UploadFormChild from "./UploadExcel";
import { Dropdown, Input, MenuProps, Form, Radio, RadioChangeEvent } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import './index.less'

export default function ImportWalletKey({ form, isWalletAddress }: any) {
  const { t } = useTranslation()
  const [opType, setOpType] = useState('simple')
  const [mode, setMode] = useState(1);
  const [isUploadFileSuccess, setIsUploadFileSuccess] = useState(false)

  const FormAddrsChild = (props: any) => {

    function onDone(value: any = '') {
      form.setFieldValue('keypair', value)
      setMode(1)
    }

    function onError(bol: any = false) {
      setIsUploadFileSuccess(bol)
    }

    function onInputCode(value: any) {
      const trimmedValue = value.replace(/ /g, ''); // 去掉所有空格
      // console.log(trimmedValue, 'value 123123');
      // setFormAddresses(trimmedValue);
      form.setFieldValue('keypair', trimmedValue);
    }

    const { t } = useTranslation()
    const placeholder = `2cWjwTX7xF1n4PqGWbvEvNS51KiJ5qZW4X4WVLuunNeoYe2cK5ZmUd2eVHfwPLqcjmMm2JiS396Urtjfvu2fPjfP`
    return (
      <div>
        <Input {...props} type={'hidden'} />
        {
          mode === 2 ? <UploadFormChild onDone={onDone} /> : <CodeMirrorInput placeholder={placeholder} code={form.getFieldValue('keypair')} onInputCode={onInputCode} onError={onError} />
        }
      </div>
    )
  }
  const options = [
    { label: t("components.manualInput"), value: 1 },
    { label: t("components.uploadFile"), value: 2 }
  ];

  const onChangeMode = ({ target: { value } }: RadioChangeEvent) => {
    // console.log('radio3 checked', value);
    setMode(value);
  }

  return (<div className="import-wallet-key-1">
    <div className='addrs-head'>
      {/* 钱包地址列表,每一行输入一个钱包地址 */}
      <div className='title'>{isWalletAddress ? t("tokenManagement.walletAddressListHint") : t("components.privateKeyListEnterOnePerLine")}</div>
      <Radio.Group options={options} onChange={onChangeMode} value={mode} optionType="button" className='option-mode' />
    </div>
    <Form.Item
      label=""
      name={"keypair"}
      // message: t("components.manuallyEnterOrUploadPrivateKey")
      // "请手动输入或上传钱包地址"
      rules={[{ required: true, message: isWalletAddress ? t("components.manualOrUploadWalletHint") : t("components.manuallyEnterOrUploadPrivateKey") }]}
    >
      <FormAddrsChild />
    </Form.Item>
  </div>)
}